import './App.css';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

// HashRouter to handle non defined server side routes
import { HashRouter as Router, Routes, Route } from 'react-router-dom';

import Home from './components/home/Home';
import Analytics from './components/analytics/Analytics'; 
import SignIn from './components/auth/SignnIn';
import Navbar from './components/Header';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';
import DataExports from './components/dataExports/FileDeliverySettings/DataExports';
import ScheduleSending from './components/dataExports/FileDeliverySettings/ScheduleSending';
import CloudScheduleSending from './components/dataExports/CloudDeliverySettings/CloudScheduleSending';
import TransferHistory from './components/dataExports/CloudDeliveryJobHistory/TransferHistory';
import Reporting from './components/reporting/Reporting';
import AccessControl from './components/access/AccessControl';
import InvitationConfirmPage from './components/invite/InvitationConfirmation';
import NotFoundPage from './components/NotFoundPage';

library.add(fas);

function App() {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 600);
  
  const fetchUserResponse = useSelector(state => state.fetchUserResponse);

  useEffect(() => {
    const handleResize = () => {
        setIsSmallScreen(window.innerWidth < 600);
    };

    window.addEventListener('resize', handleResize);

    return () => {
        window.removeEventListener('resize', handleResize);
    };
  }, []);
  
  return (
    <Router>
      <Navbar
        isSmallScreen={isSmallScreen}
      />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/auth/signin' element={<SignIn />} />  
        <Route path='/analytic' element={<Analytics />} />
        <Route path='/invite/confirm-invitation' element={<InvitationConfirmPage />} />

        <Route path='/access' element={
          <ProtectedRoute allowedRoles={['admin', 'supervisor', 'tla']}>
            <AccessControl />
          </ProtectedRoute>
        } />
        <Route path='/csv/download' element={
          <ProtectedRoute allowedRoles={['admin', 'tla']}>
            <DataExports />
          </ProtectedRoute>
        } />
        <Route path='/csv/scheduler' element={
          <ProtectedRoute allowedRoles={['admin', 'tla']}>
            <ScheduleSending />
          </ProtectedRoute>
        } />
        <Route path='/cloud/scheduler' element={
          <ProtectedRoute allowedRoles={['admin', 'tla']}>
            <CloudScheduleSending />
          </ProtectedRoute>
        } />
        <Route path='/cloud/transfer-history' element={
          <ProtectedRoute allowedRoles={['admin', 'tla']}>
            <TransferHistory />
          </ProtectedRoute>
        } />
        <Route path='/reporting' element={
          <ProtectedRoute allowedRoles={['admin', 'tla']}>
            <Reporting />
          </ProtectedRoute>
        } />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
     <Footer />
    </Router>
  );
}

export default App;